import { render, staticRenderFns } from "./CharBook.vue?vue&type=template&id=511023c8&scoped=true&"
import script from "./CharBook.vue?vue&type=script&lang=js&"
export * from "./CharBook.vue?vue&type=script&lang=js&"
import style0 from "./CharBook.vue?vue&type=style&index=0&id=511023c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511023c8",
  null
  
)

export default component.exports